import React, { forwardRef, useContext, useState, useRef, useEffect } from 'react';
import {
    Container,
    FilterMainText,
    FilterSelectDiv,
    FilterSelectInput,
    FilterSelectImg,
    ApplyFilterButton,
    DropdownOption,
    DropdownContainer
} from './style';
import TableFiltersContext from '../../../contexts/TableFiltersContext';
import down from '../../../assets/stock/FilterMenu/angle-down.svg';


type RouterFiltersMenuProps = object

const RouterFiltersMenu = forwardRef<HTMLDivElement, RouterFiltersMenuProps>((props, forwardRef) => {
    const context = useContext(TableFiltersContext);

    if (!context) {
        console.error('TableFiltersContext not found. Ensure TableFiltersProvider is used.');
        return null;
    }

    const [fieldsDropdownOpen, setFieldsDropdownOpen] = useState<boolean>(false);
    const [filtersDropdownOpen, setFiltersDropdownOpen] = useState<boolean>(false);

    const [selectedField, setSelectedField] = useState<string>(''); 
    const [selectedFilterType, setSelectedFilterType] = useState<string>(''); 

    const fieldsRef = useRef<HTMLDivElement>(null);
    const filtersRef = useRef<HTMLDivElement>(null);

    const routerFilterableFields = ['Status'];

    const routerStatusOptions = [
        'A programar',
        'Rota concluída'
    ]; 




    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (fieldsRef.current && !fieldsRef.current.contains(event.target as Node)) {
                setFieldsDropdownOpen(false);
            }
            if (filtersRef.current && !filtersRef.current.contains(event.target as Node)) {
                setFiltersDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name } = e.target;
        if (name === 'field') {
            setSelectedField('Status');
            setSelectedFilterType(''); // Reset o tipo ao selecionar o campo
            setFieldsDropdownOpen(false);
        }
    };

    const handleNewField = (value: string) => {
        setSelectedField(value);
        setFieldsDropdownOpen(false);
        setSelectedFilterType(''); // Reset o tipo ao selecionar o campo
    };

    const handleNewFilterType = (value: string) => {
        setSelectedFilterType(value);
        setFiltersDropdownOpen(false);
    };

    const submitFilter = () => {
        if (!selectedField || !selectedFilterType) {
            alert("Por favor, selecione um campo e um tipo de filtro!");
            return;
        }

        if (selectedField === 'Status') {
            context.setRouterStatusFilter(selectedFilterType);
        } 
        


        setSelectedField('');
        setSelectedFilterType('');
    };

    const FilterInputComponent: React.FC = () => {
        if (!selectedField) {
            return (
                <FilterSelectDiv>
                    <FilterSelectInput
                        placeholder='Preencha acima'
                        disabled
                    />
                </FilterSelectDiv>
            );
        }
        
        return (
            <FilterSelectDiv>
                <FilterSelectInput
                    placeholder='Tipo de filtro'
                    name='filterType'
                    value={selectedFilterType}
                    onChange={handleChange}
                    onClick={() => setFiltersDropdownOpen(true)}
                    autoComplete="off"
                    readOnly
                />
                <FilterSelectImg src={down} alt='Seta para baixo' onClick={() => setFiltersDropdownOpen(!filtersDropdownOpen)}/>
                {filtersDropdownOpen && (
                    <DropdownContainer ref={filtersRef}>
                        {routerStatusOptions.map(type => (
                            <DropdownOption key={type} onClick={() => handleNewFilterType(type)}>
                                {type}
                            </DropdownOption>
                        ))}
                    </DropdownContainer>
                )}
            </FilterSelectDiv>
        );
    };

    return(
        <Container ref={forwardRef}>
            <FilterMainText>Filtrar</FilterMainText>

            <FilterSelectDiv>
                <FilterSelectInput
                    placeholder='Filtrar por'
                    name='field'
                    value={selectedField}
                    onChange={handleChange}
                    onClick={() => setFieldsDropdownOpen(true)}
                    autoComplete="off"
                    readOnly
                />
                <FilterSelectImg src={down} alt='Seta para baixo' onClick={() => setFieldsDropdownOpen(!fieldsDropdownOpen)}/>
                {fieldsDropdownOpen && (
                    <DropdownContainer ref={fieldsRef}>
                        {routerFilterableFields.map(field => (
                            <DropdownOption key={field} onClick={() => handleNewField(field)}>
                                {field}
                            </DropdownOption>
                        ))}
                    </DropdownContainer>
                )}
            </FilterSelectDiv>

            <FilterInputComponent/>

            <ApplyFilterButton onClick={submitFilter}>Aplicar filtro</ApplyFilterButton>
        </Container>
    );
});

RouterFiltersMenu.displayName = "RouterFiltersMenu";

export default RouterFiltersMenu;